/**
 * The pricing plan feature-matrix catalogue - one entry per checkmark row on
 * the pricing page, grouped the same way. A plain constant (not DB-seeded
 * like the menu-access catalogue) - this is admin-editable pricing-page
 * metadata, not an access-control entitlement, so it doesn't need its own
 * migration/table; values are stored per-plan in the existing `plan_features`
 * table (`feature_key` = each `key` below, `value_boolean`).
 */
export const PLAN_FEATURE_CATALOG = [
    {
        key: 'messaging.shared_inbox',
        label: 'Shared WhatsApp inbox for your team',
        groupLabel: 'Messaging & Inbox',
    },
    {
        key: 'messaging.templates_media_docs',
        label: 'Approved message templates, images and documents',
        groupLabel: 'Messaging & Inbox',
    },
    {
        key: 'messaging.interactive_buttons_lists',
        label: 'Interactive buttons and list messages',
        groupLabel: 'Messaging & Inbox',
    },
    {
        key: 'messaging.auto_reply_keywords',
        label: 'Auto-reply and keyword replies',
        groupLabel: 'Messaging & Inbox',
    },
    {
        key: 'messaging.multilingual_replies',
        label: 'Replies in English, Hindi and Marathi',
        groupLabel: 'Messaging & Inbox',
    },
    {
        key: 'crm.contacts_tags_notes',
        label: 'Contacts, tags, custom fields, notes',
        groupLabel: 'CRM',
    },
    { key: 'crm.tasks_followups', label: 'Tasks and follow-ups with reminders', groupLabel: 'CRM' },
    { key: 'crm.team_roles_permissions', label: 'Team roles and permissions', groupLabel: 'CRM' },
    { key: 'crm.contact_import', label: 'Contact import (CSV, Excel, VCF)', groupLabel: 'CRM' },
    {
        key: 'crm.leads_pipeline',
        label: 'Leads pipeline board (drag-and-drop, Won / Lost / Hold)',
        groupLabel: 'CRM',
    },
    {
        key: 'crm.stale_lead_followup',
        label: 'Automatic follow-up for stale leads',
        groupLabel: 'CRM',
    },
    {
        key: 'automation.appointment_booking',
        label: 'Appointment booking on WhatsApp',
        groupLabel: 'Automation & Flows',
    },
    {
        key: 'automation.product_ordering',
        label: 'Product ordering on WhatsApp',
        groupLabel: 'Automation & Flows',
    },
    {
        key: 'automation.catalog_bulk_import',
        label: 'Products and services catalog with bulk import',
        groupLabel: 'Automation & Flows',
    },
    {
        key: 'marketing.campaigns',
        label: 'WhatsApp campaigns to saved segments',
        groupLabel: 'Marketing',
    },
    {
        key: 'marketing.stop_optout',
        label: 'Automatic STOP opt-out handling',
        groupLabel: 'Marketing',
    },
];
//# sourceMappingURL=plan-features.js.map